// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from DrawerInline.module.scss  */
.DrawerInline-module-Root_4ea {
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  width: auto;
  height: 100%;
  transition-timing-function: ease;
  transition-property: width; }

.DrawerInline-module-Content_3h6 {
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  max-height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .DrawerInline-module-Content_3h6::-webkit-scrollbar {
    display: none; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Drawer/DrawerInline/DrawerInline.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,0BAA0B,EAAE;;AAE9B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB,EAAE;EACvB;IACE,aAAa,EAAE","sourcesContent":["/*  imported from DrawerInline.module.scss  */\n.DrawerInline-module-Root_4ea {\n  position: fixed;\n  z-index: 500;\n  top: 0;\n  left: 0;\n  width: auto;\n  height: 100%;\n  transition-timing-function: ease;\n  transition-property: width; }\n\n.DrawerInline-module-Content_3h6 {\n  overflow: hidden;\n  overflow-y: auto;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  -ms-overflow-style: none;\n  scrollbar-width: none; }\n  .DrawerInline-module-Content_3h6::-webkit-scrollbar {\n    display: none; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
